export enum MeetingViewEventType {
  MEETING_STARTED,
}

export enum DialogEvents {
  ADD_ATTENDEE = 'add-attendee',
}
